import { SvgIcon, SvgIconProps } from "@mui/material";
import React from "react";

const HalfCircleLeftIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    sx={{ width: 38, height: 38 }}
    {...props}
  >
    <path
      d="M0 0H19C29.4934 0 38 8.50659 38 19C38 29.4934 29.4934 38 19 38H0V0Z"
      fill="white"
    />
    <path
      d="M20.4764 8.08612C21.0674 8.08608 21.6001 8.44202 21.8262 8.98796C22.0524 9.53389 21.9274 10.1623 21.5095 10.5801L13.5893 18.5L21.5095 26.4198C22.0801 26.9903 22.0801 27.9154 21.5095 28.4859C20.939 29.0565 20.0139 29.0565 19.4434 28.4859L10.4904 19.533C10.2164 19.259 10.0625 18.8874 10.0625 18.5C10.0625 18.1125 10.2164 17.7409 10.4904 17.4669L19.4434 8.51396C19.7171 8.23956 20.0889 8.08559 20.4764 8.08612Z"
      fill="#000D8C"
    />
  </SvgIcon>
);

export default HalfCircleLeftIcon;
